import { Epic, ofType as rxOfType } from 'redux-observable';
import { Action } from 'redux';
import { catchError, map, mergeMap, switchMap, takeUntil } from 'rxjs/operators';
import { timer } from 'rxjs';
import { TrackEvent } from '@alycecom/services';
import { ofType } from '@alycecom/utils';

import {
  sendThanksRequest,
  sendThanksSuccess,
  sendThanksFail,
  thanksStatusRequest,
  thanksStatusSuccess,
  thanksStatusFail,
  pollThanksRedeemStatus,
} from './thanks.actions';
import { IThanksResponse } from './thanks.types';

export const statusThanksEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(thanksStatusRequest),
    mergeMap(({ payload: { hashId } }) =>
      apiService.get(`/api/recipient/${hashId}/thank-you`).pipe(
        map((payload: IThanksResponse) => thanksStatusSuccess(payload)),
        catchError(errorHandler({ callbacks: thanksStatusFail })),
      ),
    ),
  );

export const redeemCheckingPollingEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(pollThanksRedeemStatus.pending),
    switchMap(({ payload: { hashId } }) =>
      timer(5000, 10000).pipe(
        takeUntil(action$.pipe(rxOfType(...[pollThanksRedeemStatus.canceled, pollThanksRedeemStatus.rejected]))),
        switchMap(() =>
          apiService.get(`/api/recipient/${hashId}/thank-you`).pipe(
            mergeMap((payload: IThanksResponse) => {
              const actions: Action[] = [];
              const isFinished = payload.redeemLink || payload.delayedGiftCard;
              if (isFinished) {
                actions.push(pollThanksRedeemStatus.canceled(payload));
              }
              return actions;
            }),
            catchError(errorHandler({ callbacks: pollThanksRedeemStatus.rejected })),
          ),
        ),
      ),
    ),
  );

export const sendThanksEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(sendThanksRequest),
    mergeMap(({ payload: { hashId, message } }) =>
      apiService.post(`/api/recipient/${hashId}/thank-you`, { body: { message } }).pipe(
        mergeMap(() => [
          sendThanksSuccess(),
          TrackEvent.actions.trackEvent({ name: 'Feedback - Sent', payload: { message } }),
        ]),
        catchError(errorHandler({ callbacks: sendThanksFail })),
      ),
    ),
  );

export const thanksEpics = [statusThanksEpic, sendThanksEpic, redeemCheckingPollingEpic];
